import {BaseAnalyticsEvent} from "./base-analytics-event";

export class ExitEvent extends BaseAnalyticsEvent {
  page: String;

  constructor(isUserHoverAd: Boolean) {
    super('', '', 'exit', 'web', true);
    this.isUserHoverAd = isUserHoverAd;
    this.page = window.location.href;
  }

  get properties() {
    const properties = super.properties;
    properties.page = this.page;
    if(this.isUserHoverAd){
      properties.clickOnAd = true;
    }
    return properties;
  }
}
